import React, { useEffect, useState } from 'react';

import { Flex } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-use';

import { GrayIconButton } from 'components/DataEntry';
import { LinkIcon } from 'components/Icons';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';
import { selectApp } from 'containers/App/selectors';

interface Props {
  label?: string;
  tooltip?: string;
}

export const CopyResourceLinkButton = (props: Props) => {
  const { label, tooltip } = props;
  const { activeTabName, resourceType, resourceUuid } = useSelector(
    selectActiveResource,
  );
  const { user } = useSelector(selectApp);
  const [copied, setCopied] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setCopied(false);
    }, 1000);

    // Cleanup to prevent memory leaks
    return () => clearTimeout(timer);
  }, [copied]);

  return (
    <Flex justify="flex-end">
      <GrayIconButton
        tooltip={
          copied
            ? 'Link copied'
            : tooltip ?? 'Get link for ' + activeTabName + ' section'
        }
        leftIcon={<LinkIcon />}
        onClick={() => {
          navigator.clipboard.writeText(
            (
              location.origin +
              '/inventory/cloud/resource/' +
              resourceType +
              '/' +
              resourceUuid +
              '?tab=' +
              activeTabName +
              '&organization=' +
              user.info.org_id
            ).toString(),
          );
          setCopied(true);
        }}
        tooltipStyles={{ tooltip: { w: 32, textAlign: 'center' } }}
      >
        {label ?? 'Get Link'}
      </GrayIconButton>
    </Flex>
  );
};
